// extracted by mini-css-extract-plugin
export default {"button":"LastButton_button__X5y6z"};